"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="hero" className="relative w-full h-screen overflow-hidden !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520135/img/film_production_set_logistics.png)]">
      {}
      <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] hover:scale-[1.02]">
        <source src="/img/hero_background_video.mp4" type="video/mp4" />
      </video>

      {}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-200/80 via-blue-600/70 to-black/90 backdrop-blur-sm" />

      <div ref={ref} className={`relative z-10 flex flex-col items-center justify-center h-full px-6 text-center transition-all duration-200 ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <h1 className="text-4xl font-bold mb-4 max-w-4xl leading-tight !text-[hsl(0,0%,0%)] md:text-6xl lg:text-7xl">
          Seamless Production Logistics for Films, Commercials, and Digital Content
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl text-white mb-8 max-w-2xl">
          We ensure your film, commercial, or digital production runs seamlessly by <strong>handling every logistical detail</strong> — from locations and sets to props, schedules, and crew coordination.
        </p>
        <Link to="/#contact">
          <Button size="lg" className="bg-blue-700 hover:bg-blue-700 cursor-pointer focus:bg-blue-700 text-base md:text-lg px-8 py-6 shadow-strong hover:shadow-strong hover:scale-[1.02] transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
            Get Started
          </Button>
        </Link>
      </div>
    </section>;
}